import { render, staticRenderFns } from "./GroupNonAutomateReqManagement.vue?vue&type=template&id=d8234144&scoped=true"
import script from "./GroupNonAutomateReqManagement.vue?vue&type=script&lang=js"
export * from "./GroupNonAutomateReqManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8234144",
  null
  
)

export default component.exports